import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {denim, grayscale, white} from '/theme/color/on.color';
import {
  alto,
  cyanBlue,
  graniteGray,
  malibu,
  toryBlue,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  coachRowRoot: {
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    marginBottom: 10,
    marginTop: 10,
  },
  container: {padding: 16, backgroundColor: white},
  rowWrapper: {
    /* flexDirection: 'row',
    alignItems: 'center', */
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    paddingVertical: 4,
  },
  itemContainer: {
    flex: 1,
    flexDirection: 'row',
    paddingVertical: 3,
    backgroundColor: white,
    alignItems: 'center',
    width: '100%',
  },
  chevronContainer: {
    width: 24,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 6,
  },
  chevron: {fontSize: 24, color: grayscale},
  avatar: {
    width: 30,
    height: 30,
    borderRadius: 16,
    marginLeft: 12,
    marginRight: 16,
    backgroundColor: '#f0f0f0',
    marginTop: 0,
  },
  nameRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    display: 'flex',
  },
  nameRowWidth: {
    width: '95%',
  },
  nameRowWidthLevel: {
    width: '90%',
  },
  nameAndBadgeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  name: {fontSize: 14, width: '100%', lineHeight: 14},
  levelBadge: {
    marginLeft: 8,
    borderRadius: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  level4thLevel: {
    backgroundColor: cyanBlue,
  },
  level5thLevel: {
    backgroundColor: malibu,
  },
  l5AndAboveLevelBadge: {
    backgroundColor: toryBlue,
  },
  levelText: {
    color: '#000',
    fontWeight: 'bold',
    fontSize: 12,
  },
  l5AndAboveLevleText: {
    color: white,
    fontWeight: 'bold',
    fontSize: 12,
  },
  role: {fontSize: 12, color: graniteGray, lineHeight: 14, marginTop: 1},
  viewTeamButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ccc',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 6,
  },
  frontLineCoachViewTeamButton: {
    backgroundColor: '#f9f9f9',
    borderWidth: 1,
    borderColor: '#ccc',
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 6,
  },
  buttonText: {
    color: '#000',
    fontWeight: 'bold',
    fontSize: 12,
  },
  nodeSeparator: {
    height: 1,
    backgroundColor: alto,
  },
  starIcon: {
    fontSize: 20,
    marginLeft: 6,
    marginRight: 16,
  },
  wishList: {
    color: denim,
  },
  UnwishList: {
    color: grayscale,
  },

  starIconSelected: {
    color: denim,
  },
  starIconUnselected: {
    color: grayscale,
  },
  boldStat: {fontWeight: 'bold'},
  verticalLine: {
    position: 'absolute',
    top: 8,
    bottom: 8,
    width: 1,
    backgroundColor: grayscale,
  },
  loadMoreFooter: {
    paddingBottom: 40,
  },
  loadMoreButton: {
    marginBottom: 30,
    paddingRight: 12,
    alignItems: 'flex-end',
    height: 40,
  },
  loadMoreText: {
    color: denim,
    height: 40,
    textAlignVertical: 'center',
  },
  loadMoreButtonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  inlineLoader: {
    marginLeft: 8,
    paddingBottom: 14,
  },

  statsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 12,
    rowGap: 2,
    marginTop: 2,
  },

  stats: {fontSize: 12, lineHeight: 13, color: '#888', marginTop: 4},
  loadMoreLoaderContainer: {
    margin: 200,
    flex: 1,
  },
  flex1: {
    flex: 1,
  },
  statsBlock: {
    flexDirection: 'column',
    rowGap: 0,
    paddingBottom: 0,
    flex: 1,
    alignSelf: 'stretch',
    minWidth: 0,
  },
  statsRowLineWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 8,
    rowGap: 0,
    flex: 1,
    minWidth: 0,
  },
  alignSelfEnd: {
    alignSelf: 'flex-end',
    paddingVertical: 2,
  },
  viewTeamButtonInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  statsRowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginTop: 6,
  },
  statsWrapper: {
    flex: 1,
    marginTop: 4,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 8,
    marginBottom: 8,
    marginRight: 6,
    marginLeft: 16,
  },
});

export const getIndentStyle = (indent: number) => ({marginLeft: indent});

export const getVerticalLineStyle = (indent: number) => ({left: indent - 12});
